import { RegisterForm } from '@/components/forms/RegisterForm'

export default function RegisterPage() {
  return <RegisterForm />
}
